import { Box, Typography } from '@mui/material'
import { footerLinksStyles } from 'src/view/layout/Footer'

const Contact = () => {
  return (
    <Box sx={footerLinksStyles.container}>
      <Typography variant="h3" sx={footerLinksStyles.heading}>
        Contact
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>For questions, tips, or correction requests:</Typography>

      <Box sx={footerLinksStyles.contactInfo}>
        <Typography variant="h5" sx={{ marginBottom: '10px' }}>
          Email:
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1.2em' }}>
          <a href="mailto:contact@proxio.media" style={{ color: '#1976d2', textDecoration: 'none' }}>
            contact@proxio.media
          </a>
        </Typography>
      </Box>
    </Box>
  )
}

export default Contact
